import { render, staticRenderFns } from "./banks.vue?vue&type=template&id=1a4737e5"
import script from "./banks.vue?vue&type=script&lang=js"
export * from "./banks.vue?vue&type=script&lang=js"
import style0 from "./banks.vue?vue&type=style&index=0&id=1a4737e5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports